<template>
    <section class="About">
        <CustomScroll class="CustomScroll">
            <div class="About-content CustomScroll-content"
            @mouseenter="setCursor"  
            @mousemove="state.isHovering = true"  
            @mouseleave="state.isHovering = false"
            >

                <div class="About-pagename">About</div>
                <div class="About-title">
                    <h2 class="About-r2l About-r2l-1" ref="elm1">{{data.first_catchline[0].text}}</h2>
                    <h2 class="About-r2l About-r2l-2" ref="elm2">{{data.second_catchline[0].text}}</h2>
                </div>
                <div class="About-text-container About-r2l About-r2l-3">
                    <div class="About-text" ref="elm3">
                        <h1>{{data.title[0].text}}</h1>
                        <p class="About-text-p">{{data.contenu[0].text}}</p>
                        <div class="About-contact">
                            <div v-for="(contact,index) in data.contact" :key="index+'adaz'" class="About-contact-direct">
                                <a target="_blank uppercase" :href="'mailto:'+contact.email[0].text"
                                    @mouseenter="state.cursorHover = true"  
                                    @mouseleave="state.cursorHover = false"
                                >{{contact.email[0].text.replace('mailto:','')}}</a>
                                <a v-if="contact.phone_number.length > 0" target="_blank" :href="contact.phone_number[0].text.replace('0', 'tel:+33')"
                                    @mouseenter="state.cursorHover = true"  
                                    @mouseleave="state.cursorHover = false"
                                    >{{contact.phone_number[0].text.replace(/\B(?=(\d{2})+(?!\d))/g, " ").replace('0', '+33 (0)')}}</a>
                                <span v-if="contact.poste.length > 0">{{contact.poste[0].text}}</span>
                            </div>
                            <a v-for="(adress,index) in data.adresse1" :key="index+'adiz'" target="_blank" class="About-contact-loc" :href="adress.url_google_map.url"
                                @mouseenter="state.cursorHover = true"  
                                @mouseleave="state.cursorHover = false"
                            >
                                <span class="About-contact-loc-address">{{adress.adresse[0].text}}</span>
                                <span class="About-contact-loc-cp">{{adress.adresse_comp[0].text}}</span>
                            </a>
                        </div>
                    </div>
                </div>
                <div ref="img" class="About-r2l About-contact-img object-fit" v-observe-visibility="{
                    callback: showImage,
                    intersection: {
                        threshold: 0.8,
                    },}">
                    <picture>
                        <img class="About-contact-img-content object-fit-content" src="img/dillinger-homme.jpg" alt="tbd">
                    </picture>
                </div>
            </div>
        </CustomScroll>
    </section>
</template>

<script>

import Data from '@/data/data.js'
import Store from '@/stores/store.js'
import GL from '@/views/GL/GL.js'
import CustomScroll from '@/components/CustomScroll.vue'

export default {
    name: 'About',
    components:{
        CustomScroll
    },
    data() {
        return {
            data: Data.getAbout()[0].data,
            state: Store.state
        }
    },
    created(){
        this.tween = { bg: 0. };
        this.updateBg();
    },
    methods: {
        setCursor() {
            this.state.isHovering = true
            this.state.cursorText = ''
        },
        updateBg(){
            GL.setInvertColor(this.tween.bg)
        },
        showImage(visible){
            if( visible){
                this.$refs.img.classList.add('is-inviewport')
            }
        },
        enterAnim(done){
            setTimeout(() => {
                TweenMax.to(this.tween, .6, { bg: 1, onUpdate: this.updateBg, onComplete: done })   
            }, 300);
        },

        leaveAnim(done){
            setTimeout(() => {     
                TweenMax.to(this.tween, 0.5, { bg: 0, onUpdate: this.updateBg, onComplete: done })
            }, 200);
        },
    },
}
</script>


<style lang="scss" scoped>
    .About{
        position: fixed;
        top: 0;
        right: 0;
        width: 100%;
        height: 100%;
        color: color(black);
        opacity: 1;

        overflow: hidden;

        .uppercase{
            text-transform: uppercase;
        }

        &-pagename{
            display: none;
        }

        // &:before{
        //     content: "";
        //     position: absolute;
        //     top: 0;
        //     left: 0;
        //     width: 100%;
        //     height: 100%;

        //     // background-color: white;
            
        //     transform: translateZ(0);
        //     transition: transform .6s $ease-out-quint;
        // }

        &-content{
            position: absolute;
            right: 0;
            width: 68%;
            padding: 100px 0 0 0;
        }

        &-title{
            font-size: rem(140px);
            text-transform: uppercase;
            line-height: 0.7;
            letter-spacing: -8px;
            font-variation-settings: "wght" 900, "wdth" 70;
            max-width: 950px;
        }

        &-text{
            width: 100%;
            max-width: 600px;

            margin-left: 5vw;
            margin-top: 80px;
            padding-bottom: 4vw;

            color: color(grey);
            font-variation-settings: "wght" 350, "wdth" 60;
            line-height: 2;
            font-size: rem(18px);

            &-p{
                white-space: pre-line;
            }

            &-container{
                position: relative;
            }

            h1{
                color: color(black);
                font-variation-settings: "wght" 450, "wdth" 40;
            }

            p + p {
                margin-top: 20px;
            }
        }

        &-contact{
            margin-top: 150px;
            color: color(black);
            text-transform: uppercase;
            line-height: 1;

            &-img{
                position: absolute;
                bottom: 30%;
                right: 0;
                width: 18%;
                max-width: 250px;
                @include aspect-ratio(9,16);
                position: absolute;

        
                @include respond-to(sm){
                    background-color: transparent;
                    @include aspect-ratio(335,477);
                    position: absolute;
                    right: 0;
                    bottom: auto;
                    margin-top: rem(70px);
                    width: calc( 100vw - 48px );
                }

                &:after{
                    content:'';
                    z-index: 99999;
                    display: block;
                    height: 9%;
                    width: 41%;
                    position: absolute;
                    top: 40%;
                    left: 5%;
                    background-color: black;
                    transform: scaleX(0) translateZ(0);
                    transition: transform 0.6s $ease-out-quint 0.4s;
                    transform-origin: top left;
                }
                &.is-inviewport:after{
                    transform: scaleX(1) translateZ(0);
                }
                
                &-content{
                    transform: translateX(100%) translateZ(0) scaleX(10);
                    transform-origin: left;
                    
                    transition: transform 1.2s $ease-out-quint;
                    will-change: transform;

                    .is-inviewport &{
                        transform: scaleX(1) translateZ(0);
                    }
                }
            }

            &-direct{
                & + &{
                    margin-top: 30px;
                }
                a,span{
                    cursor: none;
                    display: block;
                    font-size: rem(36px);
                    color: color(black);
                    text-decoration: none;
                    font-variation-settings: "wght" 700, "wdth" 60;
                    transition: 0.2s ease-in-out all;
                    letter-spacing: -1px;
                    @include respond-to(md){
                        letter-spacing: 0;
                        font-size: rem(24px);
                    }
                }

                a:hover {
                    font-variation-settings: "wght" 800, "wdth" 40;
                }
            }
            &-loc{
                display: block;
                margin-top: 60px;
                cursor: none;
                font-size: rem(18px);
                color: color(black);
                text-decoration: none;

                & + &{
                    margin-top: 18px;
                }

                @include respond-to(md){
                    margin-top: 25px;
                    font-size: rem(14px);
                }
                
                &-address{
                    font-variation-settings: "wght" 700, "wdth" 60;
                }
            }
            span{
                display: block;
            }
        }

        .CustomScroll{
            height: 100%;
            width: 100%;
            overflow: hidden;

            @include respond-to(md){
                overflow-y: auto;
            }
        }
    }


    // // // // // // // // // 
    // TRANSITION HANDLING //
    // // // // // // // // // 

    .About-r2l{
        // transform:;
        transition: transform .6s $ease-out-quint;
        @for $i from 1 through 5 {
            &.About-r2l-#{$i}{
                transition-delay: (0.3s + 0.08s * $i);
                @include respond-to(md){
                    transition-delay: 0.5s + (0.08s * $i);
                }
            }
        }
    }

    .v-enter, .v-leave-to {
        .About-r2l{
            transform: translateX(70vw);
            @include respond-to(md){
                transform: translateX(100vw);
            }
        }
        // &.About:before{            
        //     transform: translateX(100%);
        // }
    }

    .v-leave-active {
        .About-r2l{
        // transform:;
        transition: transform .6s $ease-out-quint;
        @for $i from 1 through 5 {
            &.About-r2l-#{$i}{
                transition-delay: (0s * $i);
            }
        }
    }
    }
    

    .isTouch {
        .About{
            z-index: zindex(mobilePage);

        &-pagename{
            margin-top: 15vw;
            display: block;
            line-height: 1;
            text-transform: uppercase;
            font-size: 10vw;
            font-variation-settings: "wght" 200, "wdth" 1;
        }

        &-content{
            position: relative;
            width: 100%;
            padding: 100px 40px;
        }

        &-title{
                margin-top: 6vw;
                font-size: 14vw;
                letter-spacing: 0px;
        }

        &-text{
            padding-bottom: 0;
            margin-left: 0;
        }

        &-contact{
            margin-top: 90px;

            &-img{
                bottom: -80px;
                right: -40px;
                width: 28%;

                        
                @include respond-to(sm){
                    background-color: transparent;
                    @include aspect-ratio(335,477);
                    position: absolute;
                    right: 0;
                    bottom: auto;
                    margin-top: rem(70px);
                    width: calc( 100vw - 48px );
                }
            }

            &-direct{
                a,span{
                    letter-spacing: 0;
                    font-size: rem(24px);
                }
            }
            &-loc{
                margin-top: 25px;
                font-size: rem(14px);
            }
        }

        .CustomScroll{
            overflow-y: auto;
        }
    }
    }
</style>
